import { useKyc } from '../../hooks/useKyc';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { MockKycPage } from '../MockKycPage';
import { SumsubKycPage } from '../SumsubKycPage';
import { useEffect, useState } from 'react';
import { type UserKycSession } from '../../types/kyc';
import { useKycSignalR } from '../../hooks/useKycSignalR';
import { routes } from '@/routes/routes';
import { useNavigate } from 'react-router-dom';

function KycPage() {
  useKycSignalR();
  const navigate = useNavigate();

  const {
    requestKycSession,
    isKycLoading,
    isUserActionRequired,
    isSessionRequesting,
  } = useKyc(true);
  const [session, setSession] = useState<UserKycSession | undefined>(undefined);
  const [isSessionRequested, setIsSessionRequested] = useState(false);

  const isLoading = isKycLoading || isSessionRequesting;

  useEffect(() => {
    if (!isLoading && !isUserActionRequired) {
      navigate(routes.kyc.base);
    }
  }, [isLoading, isUserActionRequired]);

  // automatically create new session if not exists or is expired
  useEffect(() => {
    async function requestSession() {
      if (isSessionRequested) return;

      const newSession = await requestKycSession();
      setSession(newSession.session);
      setIsSessionRequested(true);
    }

    requestSession();
  }, []);

  if (isLoading) {
    return <PageLoader />;
  }

  if (session?.providerName === 'mock') {
    return <MockKycPage session={session} />;
  }

  if (session?.providerName === 'sumsub') {
    return <SumsubKycPage session={session} />;
  }

  return null;
}

export default KycPage;
